export const timeout = (ms: number): Promise<void> =>
    new Promise((resolve) => {
        setTimeout(resolve, ms);
    });

export const safe = async <T>(
    promise: Promise<T>,
    errorCallback?: (error: unknown) => void
): Promise<T | undefined> => {
    let res: T | undefined;
    try {
        res = await promise;
    } catch (e) {
        if (errorCallback) errorCallback(e);
        res = undefined;
    }
    return res;
};
